/*
 *
 * ControlPanelUserManagementAmbassador actions
 *
 */

import {
  GET_EMPLOYEES_DIVISIONS_WATCHER,
  GET_EMPLOYEES_DIVISIONS_FAILED,
  GET_EMPLOYEES_DIVISIONS_SUCCESS,
  CREATE_AMBASSADOR_WATCHER,
  CREATE_AMBASSADOR_FAILED,
  CREATE_AMBASSADOR_SUCCESS,
  LIST_AMBASSADORS_WATCHER,
  LIST_AMBASSADORS_SUCCESS,
  LIST_AMBASSADORS_FAILED,
  DELETE_AMBASSADOR_WATCHER,
  DELETE_AMBASSADOR_SUCCESS,
  DELETE_AMBASSADOR_FAILED,
  GET_TEMPLATE_WATCHER,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAILED,
  GET_LANGUAGE_WATCHER,
  GET_LANGUAGE_SUCCESS,
  GET_LANGUAGE_FAILED,
} from "./constants"

// GET LANGAUGE
export function getLanguageWatcher(payload) {
  return {
    type: GET_LANGUAGE_WATCHER,
    payload,
  }
}

export function getLanguageSuccess(payload) {
  return {
    type: GET_LANGUAGE_SUCCESS,
    payload,
  }
}

export function getLanguageFailed(payload) {
  return {
    type: GET_LANGUAGE_FAILED,
    payload,
  }
}
export function getEmployeesDivisionsWatcher(payload) {
  return {
    type: GET_EMPLOYEES_DIVISIONS_WATCHER,
    payload,
  }
}

export function getEmployeesDivisionsSuccess(payload) {
  return {
    type: GET_EMPLOYEES_DIVISIONS_SUCCESS,
    payload,
  }
}

export function getEmployeesDivisionsFailed(payload) {
  return {
    type: GET_EMPLOYEES_DIVISIONS_FAILED,
    payload,
  }
}

// CREATE

export function createAmbassadorWatcher(payload) {
  return {
    type: CREATE_AMBASSADOR_WATCHER,
    payload,
  }
}

export function createAmbassadorSuccess(payload) {
  return {
    type: CREATE_AMBASSADOR_SUCCESS,
    payload,
  }
}

export function createAmbassadorFailed(payload) {
  return {
    type: CREATE_AMBASSADOR_FAILED,
    payload,
  }
}

// LIST

export function listAmbassadorsWatcher(payload) {
  return {
    type: LIST_AMBASSADORS_WATCHER,
    payload,
  }
}

export function listAmbassadorsSuccess(payload) {
  return {
    type: LIST_AMBASSADORS_SUCCESS,
    payload,
  }
}

export function listAmbassadorsFailed(payload) {
  return {
    type: LIST_AMBASSADORS_FAILED,
    payload,
  }
}

// DELETE

export function deleteAmbassadorWatcher(payload) {
  return {
    type: DELETE_AMBASSADOR_WATCHER,
    payload,
  }
}

export function deleteAmbassadorSuccess(payload) {
  return {
    type: DELETE_AMBASSADOR_SUCCESS,
    payload,
  }
}

export function deleteAmbassadorFailed(payload) {
  return {
    type: DELETE_AMBASSADOR_FAILED,
    payload,
  }
}

// GET TEMPLATE
export function getTemplate(payload) {
  return {
    type: GET_TEMPLATE_WATCHER,
    payload,
  }
}

export function getTemplateSuccess(payload) {
  return {
    type: GET_TEMPLATE_SUCCESS,
    payload,
  }
}

export function getTemplateFailed(payload) {
  return { type: GET_TEMPLATE_FAILED }
}
